import React from "react";
import { Toaster, useToastController } from "@fluentui/react-components";
import { useId } from "@fluentui/react-hooks";

export const useAppToast = () => {
  return {
    toastId: useId("updateToast"),
    useToastController: useToastController("toaster5"),
    appToaster: () => {
      return <Toaster toasterId="toaster5" limit={5} />;
    },
  };
};
